import React from "react";
import ConsentFormBase from "./ConsentFormBase";
// Reuse the existing PDF generator for the Print button. Adjust this import path
// to match however PatientSections.js imports it (it's referenced there as
// Components.PrintSurgeryConsent — use whatever the actual relative path is).
import PrintSurgeryConsent from "../patient/print/PrintSurgeryConsent";
import { ConsentTemplateType, FormGroupName } from "../../shared/constants";


const SurgeryConsentForm = (props) => (
  <ConsentFormBase
    {...props}
    groupname={FormGroupName.Surgery_Consent_Form} 
    templateType={ConsentTemplateType.Surgery_Consent_Form}
    // subgroup="surgery_consent"
    formTitle="Surgery Consent Form"
    includeWardAndDiagnosis={true} 
    PrintComponent={PrintSurgeryConsent}
  />
); 

export default SurgeryConsentForm;
